import { z } from 'zod';

/**
 * Message pushed over `GET /v1/branches/:branchId/realtime` (WebSocket). It is a hint:
 * clients re-fetch the canonical entity from the API (spec §10) — never apply payloads
 * as state, and re-fetch everything after reconnect.
 */
export const realtimeMessageSchema = z.object({
  event_id: z.string(),
  event_type: z.string(),
  branch_id: z.string(),
  entity_id: z.string(),
  /** Version after the change; 0 = unversioned hint (e.g. order status touched by the kitchen). */
  entity_version: z.number().int(),
  occurred_at: z.string(),
  /** Kitchen station for ticket events, so KDS screens can filter. */
  station_id: z.string().nullable(),
});
export type RealtimeMessage = z.infer<typeof realtimeMessageSchema>;
